import React, { lazy, Suspense } from 'react';
import { createMemoryRouter, RouterProvider, useRouteError } from 'react-router-dom';
import { routes } from './routesConfig';
import ProtectedRoute from './ProtectedRoutes';

const App = lazy(() => import(/* webpackChunkName: "app" */ './Routelets/App'));
const Home = lazy(() => import(/* webpackChunkName: "Home" */ 'pages/Home'));
const Leaderboard = lazy(() => import(/* webpackChunkName: "Leaderboard" */ 'pages/Leaderboard'));
const MyPicks = lazy(() => import(/* webpackChunkName: "Leaderboard" */ 'pages/MyPicks'));
const PlayerList = lazy(() => import(/* webpackChunkName: "Leaderboard" */ 'pages/PlayerList'));
const HowToPlay = lazy(() => import(/* webpackChunkName: "HowToPlay" */ 'pages/HowToPlay'));
const Prizes = lazy(() => import(/* webpackChunkName: "Leaderboard" */ 'pages/Prizes'));
const Terms = lazy(() => import(/* webpackChunkName: "Leaderboard" */ 'pages/Terms'));
// const Faqs = lazy(() => import(/* webpackChunkName: "Leaderboard" */ 'pages/Faqs'));
const Rules = lazy(() => import(/* webpackChunkName: "Leaderboard" */ 'pages/Rules'));
const CreateTeam = lazy(() =>
  import(/* webpackChunkName: "CreateTeam" */ '../components/ui/createTeam')
);
const AppLayout = lazy(() =>
  import(/* webpackChunkName: "AppLayout" */ '../components/ui/applayout')
);

const childRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: routes.mypicks.path,
    element: <MyPicks />
  },
  {
    path: routes.leaderboard.path,
    element: <Leaderboard />
  },

  {
    path: routes.playerlist.path,
    element: <PlayerList />
  },

  {
    path: routes.howtoplay.path,
    element: <HowToPlay />
  },
  {
    path: routes.rules.path,
    element: <Rules />
  },
  {
    path: routes.terms.path,
    element: <Terms />
  },
  // {
  //   path: routes.faqs.path,
  //   element: <Faqs />
  // },
  {
    path: routes.createteam.path,
    element: <CreateTeam />
  },
  {
    path: '*',
    element: <Home />
  }
];

function ErrorBoundary() {
  let error = useRouteError();
  return <div>something went wrong</div>;
}

const route = [
  {
    path: '/',
    element: <AppLayout />,
    children: childRoutes,
    errorElement: <ErrorBoundary />
  }
];

export const router = createMemoryRouter(route, {});

const Routes = () => {
  return (
    <Suspense>
      <RouterProvider router={router} />
    </Suspense>
  );
};
export default Routes;
